import { RedirectUrls } from 'src/types/types'

export enum DashboardViews {
  Rent = 'rent',
  Host = 'host'
}

/**
 * Maps Next.js pathname patterns to RedirectUrls for sidebar active-state.
 * Dynamic routes use their base path (e.g. /dashboard/host/team covers /team/[id]).
 */
export const PATHNAME_TO_REDIRECT_URL: Record<string, RedirectUrls> = {
  '/dashboard': RedirectUrls.Dashboard,
  '/dashboard/host': RedirectUrls.Dashboard,
  '/dashboard/host/listings': RedirectUrls.Listings,
  '/dashboard/host/listings/[id]': RedirectUrls.Listings,
  '/dashboard/host/listings/[id]/edit': RedirectUrls.Listings,
  '/dashboard/host/rents': RedirectUrls.Rents,
  '/dashboard/host/messages': RedirectUrls.HostMessages,
  '/dashboard/host/messages/chat/[id]': RedirectUrls.HostMessages,
  '/dashboard/host/messages/recipient/[id]': RedirectUrls.HostMessages,
  '/dashboard/host/profile': RedirectUrls.HostProfile,
  '/dashboard/host/referral': RedirectUrls.Referral,
  '/dashboard/host/team': RedirectUrls.Team,
  '/dashboard/host/team/[id]': RedirectUrls.Team,
  '/dashboard/host/closed-deals': RedirectUrls.HostClosedDeals,
  '/dashboard/host/closed-deals/[id]': RedirectUrls.HostClosedDeals,
  '/dashboard/host/interesados': RedirectUrls.HostInteresados,
  '/dashboard/host/pagos': RedirectUrls.HostPayments,
  '/dashboard/rent': RedirectUrls.DashboardRent,
  '/dashboard/rent/reservations': RedirectUrls.Reservations,
  '/dashboard/rent/messages': RedirectUrls.RentMessages,
  '/dashboard/rent/messages/chat/[id]': RedirectUrls.RentMessages,
  '/dashboard/rent/messages/recipient/[id]': RedirectUrls.RentMessages,
  '/dashboard/rent/profile': RedirectUrls.RentProfile,
  '/dashboard/admin': RedirectUrls.Admin,
  '/checkoutDetails/[id]': RedirectUrls.CheckoutDetails
}
